import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function BackHomeButton({ className = '', style = {}, children = null }) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={`back-home-btn ${className}`.trim()}
      style={style}
      onClick={() => navigate('/')}
    >
      {children || '← Back to Home'}
    </button>
  );
}
